module.exports = __webpack_public_path__ + "static/media/FamilyNightStyleGuide.922de20f.jpg";